import React from "react";
import Loading from "@/common/components/Loading";
import PopUp from "@/common/components/PopUp";
import { Title } from "../../AdminCommandPage.styled";
import ClearCsvForm from "./components/ClearCsvForm";
import useClearCsvImportedData from "./hooks/useClearCsvImportedData";

const ClearCsvImportedData = ({ setClose, reloadMutation }) => {
  const {
    languagesOptions,
    selectedLanguage,
    setSelectedLanguage,
    isLoading,
    handleCreateJobProcess,
  } = useClearCsvImportedData({ setClose, reloadMutation });

  return (
    <>
      {isLoading && <Loading />}
      <PopUp setClose={setClose}>
        <Title>Clear CSV imported data</Title>
        <ClearCsvForm
          languagesOptions={languagesOptions}
          selectedLanguage={selectedLanguage}
          setSelectedLanguage={setSelectedLanguage}
          handleCreateJobProcess={handleCreateJobProcess}
        />
      </PopUp>
    </>
  );
};

export default ClearCsvImportedData;
